import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure43 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      xAxis: [{
        categories: [ 2015, 2016, 2017, 2018, 2019, 2020 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        gridLineWidth: 2,
        max: 20,
        min: 16,
        tickInterval: 1,
	title: {
	useHTML: true,			
            text: "USD / m³",
	    style: {
		fontWeight: 'normal',
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
	    series: {
			    borderWidth: 0,
			    stacking: 'normal',
			    dataLabels: {
						 enabled: true,
						 formatter: function () {
		    // 'this.y' contains the data value of the point
						return Highcharts.numberFormat(this.y,2) + ''; // Format the value as Pourcentage with 2 decimal places
							  },
					 },

		    },
            states: {
                hover: {
                    lineWidth: 2
		       },
		    },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
    },
    series: [ 
        
    {
        marker: {
            enabled: false
		},
		name:'',
        type: 'line',
        color: '#5b9bd6',
        zoneAxis: 'x',
        data: [
            17.4, 17.8, 18.32, 19.12, 19.4, 18.9
        ],
    },
  ],

}